import * as React from 'react';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import TipsAndUpdatesOutlined from '@mui/icons-material/TipsAndUpdatesOutlined';
import Tooltip from '@mui/material/Tooltip';
import { getFileDataFromEvent, readFileAsDataUrl } from './UtilsDom';
import { throwIfEquals, throwIfNone } from './UtilsLogic';
import { TabPanel } from './MuiTabsAlwaysMounted/TabPanel';
import {
	COMMANDSHINT,
	ERROR_INPUT_FILESELECT,
	TABLABEL_BG_UPLOAD,
	TABLABEL_BG_URL,
	LABEL_BG_URL,
} from './const';

const LOCAL_IMAGE_INPUT_ID = 'local-image';

export type P_BgImageSelectTabs = {
	url: string;
	onUrlChange: (e: string) => any;
	onFileImageLoaded: (e: string) => any;
};
const BgImageSelectTabs = React.memo(
	(props: P_BgImageSelectTabs) => {
		const [state_currentTabId, set_currentTabId] = React.useState('1');
		const handleChange = (
			event: React.SyntheticEvent<Element, Event>,
			value: any,
		) => set_currentTabId(value);

		const _onUrlChange = React.useCallback(
			(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
				props.onUrlChange(e.target.value);
				const fileDom = getFileInputElement();
				if (fileDom) {
					fileDom.value = '';
				}
			},
			[],
		);

		return (
			<TabContext value={state_currentTabId}>
				<Box
					sx={{ borderBottom: 1, borderColor: 'divider' }}
					style={{ marginTop: 0 }}
				>
					<TabList
						value={state_currentTabId}
						variant='standard'
						onChange={handleChange}
					>
						<Tab label={TABLABEL_BG_URL} value='1' sx={{ fontSize: '80%' }} />
						<Tab
							label={TABLABEL_BG_UPLOAD}
							value='2'
							sx={{ fontSize: '80%' }}
						/>
					</TabList>
				</Box>
				<Box
					style={{
						position: 'relative',
						marginTop: 16,
					}}
				>
					{/*高さを確保するために1つだけrelativeにする。 */}
					<TabPanel value='1' style={{ position: 'relative' }}>
						<TextField
							id='bgimage-url-input'
							label={LABEL_BG_URL}
							variant='outlined'
							size='small'
							fullWidth
							value={props.url}
							onChange={_onUrlChange}
						/>
						<Tooltip title={COMMANDSHINT} placement='top' enterTouchDelay={0}>
							<IconButton>
								<TipsAndUpdatesOutlined />
							</IconButton>
						</Tooltip>
					</TabPanel>
					<TabPanel value='2'>
						<Input onFileImageLoaded={props.onFileImageLoaded} />
					</TabPanel>
				</Box>
			</TabContext>
		);
	},
	(prevP, nextP) => prevP.url === nextP.url,
);

const Input = (props: { onFileImageLoaded: (url: string) => any }) => {
	React.useEffect(() => {
		const dom = getFileInputElement();
		if (!dom) {
			return;
		}
		dom.addEventListener(
			'change',
			function (e) {
				const r = R.tryCatch(
					R.pipe(
						getFileDataFromEvent,
						throwIfNone,
						(e) => (e.type.match('image.*') ? e : false),
						throwIfEquals<File>(false),
						(e) => readFileAsDataUrl(e, props.onFileImageLoaded),
					),
					R.always(false),
				)(e);
				if (r === false) {
					alert(ERROR_INPUT_FILESELECT);
					return;
				}
			},
			false,
		);
	}, []);

	return <input id={LOCAL_IMAGE_INPUT_ID} type='file' accept='image/*' />;
};

const getFileInputElement = () =>
	document.getElementById(LOCAL_IMAGE_INPUT_ID) as HTMLInputElement | null;

export default BgImageSelectTabs;
